module.exports = __webpack_public_path__ + "static/media/7Mapview.6ef5e244.png";